import { API_URLS } from "../../../config";
import { CallApi } from "./api/callApi";
import { call, put } from 'redux-saga/effects'
import { fileUploaded } from "../../redux/slices/fileSlice";

export function* uploadFileSaga(action) {
    try {
        const data = action.payload;
        const { name, formData } = data?.data
        // const resp = null;
        const resp = yield call(CallApi.POST, API_URLS.FILES.UPLOAD_FILES, formData, data?.token)
        // //console.log(resp);
        // //console.log({ name })+
        if (resp && resp?.status && resp.status >= 200 && resp.status < 300 && resp?.data && resp?.data?.success) {
            yield put(fileUploaded())
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            yield put(fileUploaded());
            action && action.callbackError && action.callbackError(resp.data);
        }
    } catch (e) {
        yield put(fileUploaded())
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* deleteFileSaga(action) {
    try {
        const data = action.payload;
        //console.log(data);
        const { id } = data?.data
        //console.log(id);
        // const resp = null;
        const resp = yield call(CallApi.DELETE, API_URLS.FILES.DELETE_FILE.replace(':id', id), null, data?.token)
        // //console.log(resp);
        // //console.log({ name })+
        if (resp && resp?.status && resp.status >= 200 && resp.status < 300 && resp?.data && resp?.data?.success) {
            yield put(fileUploaded())
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            yield put(fileUploaded());
            action && action.callbackError && action.callbackError(resp.data);
        }
    } catch (e) {
        yield put(fileUploaded())
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* replaceFileSaga(action) {
    try {
        const data = action.payload;
        //console.log(data);
        const { id, formData, name: fileName } = data?.data
        //console.log(id,fileName);
        // const resp = null;
        const resp = yield call(CallApi.PUT, API_URLS.FILES.REPLACE_FILE.replace(':id', id), formData, data?.token)
        // //console.log(resp);
        // //console.log({ name })+
        if (resp && resp?.status && resp.status >= 200 && resp.status < 300 && resp?.data && resp?.data?.success) {
            // yield put(replaceFileChange({fileName,data:resp?.data?.data}))
            yield put(fileUploaded())
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            yield put(fileUploaded());
            action && action.callbackError && action.callbackError(resp.data);
        }
    } catch (e) {
        yield put(fileUploaded())
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
